import * as CL from '@design-system/component-library';
import { additionalInformationMsg, t } from '../../../common/i18n';
import { useOpenFormAsync } from '../OpenFormProvider.js';
import { OpenFormIcon } from './OpenFormIcon.js';

export const OpenFormKnowledgeArticleLink = ({ knowledgeBaseURL }: { knowledgeBaseURL: string }) => {
  const async = useOpenFormAsync();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    async.frame.postMessageOpenLink(knowledgeBaseURL);
  };

  return (
    <div className="of-openform__link of-openform__link">
      <CL.Link linkStyle="link" onClick={handleClick}>
        {t.GZUK(additionalInformationMsg)}
        <OpenFormIcon icon="external-link"></OpenFormIcon>
      </CL.Link>
    </div>
  );
};
